<template>
  <div class="phd-license-toggle" role="radiogroup" aria-label="How are you using HOT?">
    <button
      type="button"
      role="radio"
      :aria-checked="value === 'chooseLMS' ? 'true' : 'false'"
      class="phd-license-pill"
      :class="{ 'phd-license-pill--on': value === 'chooseLMS' }"
      @click="emit('chooseLMS')"
    >Use HOT's LMS</button>
    <button
      type="button"
      role="radio"
      :aria-checked="value === 'chooseOtherPlatform' ? 'true' : 'false'"
      class="phd-license-pill"
      :class="{ 'phd-license-pill--on': value === 'chooseOtherPlatform' }"
      @click="emit('chooseOtherPlatform')"
    >License our Content</button>
  </div>
</template>

<script>
export default {
  name: 'LicenseModeChooser',

  // v-model contract — value is one of: 'chooseLMS' | 'chooseOtherPlatform'.
  // Mirrors the legacy ChoosePlatform.vue radio shape so backend handlers
  // that already key off `choose_platform` keep working unchanged.
  props: {
    value: {
      type: String,
      default: 'chooseLMS',
      validator: (v) => v === 'chooseLMS' || v === 'chooseOtherPlatform',
    },
  },

  methods: {
    emit(mode) {
      if (mode !== this.value) this.$emit('input', mode);
    },
  },
};
</script>

<style lang="scss" scoped>
/* Segmented-control pattern — same visual rhythm as the billing-cycle
   toggle (.ph-cycle-toggle) so the page reads as one design system.
   Sits inline above the plans grid; quiet by default, only the active
   pill draws attention. */
.phd-license-toggle {
  display: inline-flex;
  align-items: stretch;
  background: #f7f7f7;
  border-radius: 999px;
  padding: 4px;
  margin: 8px 0 18px;
  gap: 2px;
  font-size: 13px;
  border: 1px solid rgba(37, 37, 37, 0.06);
}

.phd-license-pill {
  border: 0;
  background: transparent;
  border-radius: 999px;
  padding: 6px 14px;
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  color: #555;
  white-space: nowrap;
  transition: background-color 160ms ease, color 160ms ease;
  font-family: inherit;
}

.phd-license-pill:hover {
  color: #1a1a1a;
}

.phd-license-pill:focus-visible {
  outline: 2px solid #fe672c;
  outline-offset: 2px;
}

.phd-license-pill--on {
  background: #fff;
  color: #1a1a1a;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

@media (max-width: 480px) {
  .phd-license-toggle {
    width: 100%;
    justify-content: stretch;
  }
  .phd-license-pill {
    flex: 1 1 0;
  }
}
</style>
